import { IconInfo } from 'components/Icons';
import { Alert } from 'components/Alert';

export const DeleteAlert = ({ text = 'Note: This operation cannot be undone.' }): JSX.Element => (
  <Alert type="error">
    <IconInfo color="#CF536C" size={18} />
    {text}
  </Alert>
);
